import { useDispatch, useSelector } from "react-redux"

import SurgicalDrawer from "./SurgicalDrawer"
import { surgicalActions } from "../../../../store/surgical"

import classes from './SurgicalDrawer.module.css'
import DateDisplayWithNmuberOfDays from "../../../common/DateDisplayWithNmuberOfDays"
import { getSurgeryApprovalStatus, getSurgicalStatus } from "../../../../lib/labels"
import { getItemFromIdGeneral } from "../../../../lib/script"
import { atpProvidersOptions } from "../../../../lib/systemData"
import { checkCurentStageForSurgery } from "../../../../lib/misc"

export default function SurgicalItem({itemData, index, activeCase}) {
    const dispatch = useDispatch()

    const showDetails = useSelector(state => state.surgical.activeDrawer)

    function showDetailshandler() {
        if (showDetails == index) {
            dispatch(surgicalActions.setActiveDrawer(null))
        } else {
            dispatch(surgicalActions.setActiveDrawer(index))
            dispatch(surgicalActions.setActiveTab(checkCurentStageForSurgery(itemData.surgery_stage) || 1))
        }        
    }   

    return <>
        <tr onClick={showDetailshandler} className={classes.surgical_item}>
            <td >
                <div className={`${classes.drawer_trigger_mark} ${showDetails == index ? classes.is_opened : ''}`}>
                    <i className='ti ti-chevron-right'></i>
                    <DateDisplayWithNmuberOfDays date={itemData.date_ordered} />                    
                </div>
            </td>
            <td>
                {getItemFromIdGeneral(activeCase.services, itemData.case_service_id, 'order_by_id') ? <>{atpProvidersOptions()?.find(item => item.value == getItemFromIdGeneral(activeCase.services, itemData.case_service_id, 'order_by_id'))?.label}</>: ''}
            </td>
            <td>
                {itemData.step_1_area}
            </td>
            <td>{itemData.step_3_approval == 1 ? getSurgeryApprovalStatus(itemData.step_3_approval_status) : null}</td>
            <td>{getSurgicalStatus(itemData.step_4_different_performing_surgeon ? itemData.step_5_status : itemData.step_4_status)}</td>
            <td>{itemData.surgery_stage}</td>
            <td>
                <DateDisplayWithNmuberOfDays date={itemData.step_4_different_performing_surgeon ? itemData.step_5_est_surgical_date : itemData.step_4_est_surgical_date} />
            </td>
            <td>
                <DateDisplayWithNmuberOfDays date={itemData.step_7_performed_date} />
            </td>
        </tr>
        {(showDetails == index) && 
            <tr className={classes.surgical_item_drawer}>
                <td colSpan={8}>
                    <SurgicalDrawer itemData={itemData} apiCase={'case_surgeries'}/>    
                </td>    
            </tr>
        }
    </>
}